import React, { Component } from 'react'
import CheckBox from "../../components/CheckBox"

class FilterContentType extends Component {

  contentTypeChanged = (isChecked, selectedValue) => {
    this.props.onContentTypeChanged(isChecked, selectedValue)
  }

  render() {

    const filterContentTypes = Array.from(new Set(this.props.relatedContents.map(c => c.contentType)))
      .filter(ct => ct == 4 || ct == 5 || ct == 7 || ct == 9)
      .map(ct => {
        return this.props.relatedContents.find(c => c.contentType === ct)
      })
      .map(c => { return { contentTypeId: c.contentType, contentTypeName: c.contentTypeName } })
      .sort((a, b) => a.contentTypeName != null && b.contentTypeName != null && a.contentTypeName.localeCompare(b.contentTypeName))

    return (
      <div className='box-inner-contenttype'>
        <div className='item-sub-header'>Content Type</div>
        {(filterContentTypes.length > 0) ?
          <div className="item-contentTypes">
            <div className="div-separator">
              <CheckBox
                id={'cbContentTypeAll'}
                Name={'cbContentTypeAll'}
                Checked={this.props.selectedContentTypeIds.length === 0}
                onTickChanged={(chk, val) => this.contentTypeChanged(chk, val)}
                Value='0' text='Show All' />
            </div>

            {filterContentTypes.map(content =>
            (
              <div key={content.contentTypeId}>
                <CheckBox
                  id={'cbContentType' + content.contentTypeId}
                  Name={'cbContentType' + content.contentTypeId}
                  Checked={this.props.selectedContentTypeIds.includes(content.contentTypeId)}
                  onTickChanged={(chk, val) => this.contentTypeChanged(chk, val)}
                  Value={content.contentTypeId} text={content.contentTypeName} />
              </div>
            ))}
          </div>
          :
          null
        }
      </div>
    )
  }
}

export default FilterContentType
